import React, { useState, useEffect, useContext } from 'react';
import { useMediaQuery } from 'react-responsive';
import PulseLoader from "react-spinners/PulseLoader";

import {AuthContext} from "../contexts/AuthContext";
import { DeviceType, TimeRange, ListDevicesRequest } from "../goveepb/internal/proto/govee_pb"
import { GoveeUIClient } from "../goveepb/internal/proto/govee_grpc_web_pb"
import {ZoomContext} from "../contexts/ZoomContext";
import PressureSensorChart from "./PressureSensorChart";
import useGrpcWithAuth from "../hooks/useGrpcWithAuth";

const PressureSensorList = () => {
  const [sensors, setSensors] = useState([]);
  const [isLoadingSensors, setIsLoadingSensors] = useState(true);
  const [errClassName, setErrClassName] = useState("err-message-hide");
  const [errMessage, setErrMessage] = useState(null);
  const { user, isLoadingUser } = useContext(AuthContext);
  const { since, until, setCustomTimeRange } = useContext(ZoomContext);
  const callWithRetry = useGrpcWithAuth();

  const client = new GoveeUIClient(process.env.REACT_APP_GRPC_URL);
  const isDesktopOrLaptop = useMediaQuery({
    query: '(min-width: 1124px)'
  });

  const fetchDevices = () => {
    console.log("fetching sensor list");
    if (isLoadingUser) {
      return;
    }

    if (!user) {
      setIsLoadingSensors(false);
      return;
    }

    const req = new ListDevicesRequest();
    req.setType(DeviceType.BME280);
    req.setTimerange(new TimeRange([since, until]));
    console.log("Fetching list of sensors with timeRange", new Date(since), new Date(until));

    callWithRetry(
      (metadata, cb) => client.listDevices(req, metadata, cb),
      (err, response) => {
        if (err) {
          console.error("Received error getting batch of sensors", err);
          var message = "An error occurred loading the list of Govee sensors";
          if (err && err.message) {
            message += ': "' + err.message + '"';
          }
          message += ". Will retry automatically."
          setErrMessage(message);
          setErrClassName("err-message-show");
          setIsLoadingSensors(false);
        } else {
          const sensorsList = response.getDevicesList();
          console.log("Received fresh batch of sensors:", sensorsList.length)
          setErrClassName("err-message-hide")
          setSensors(sensorsList);
          setIsLoadingSensors(false);
        }
      }
    );
  }

  useEffect(() => {
    if (isLoadingUser) {
      return;
    }

    console.log("PressureSensorList: use effect, about to fetch Devices")
    fetchDevices();
  }, [user, isLoadingUser, since, until]);

  const onDragZoom = (left, right) => {
    console.log("onDragZoom, setting custom time range", new Date(left), new Date(right));
    setCustomTimeRange(left, right, "Custom");
  };

  const charts = sensors.map((sensor, index) => {
    return (
        <li className="sensor-list-entry" key={sensor.getId()}>
          <PressureSensorChart key={sensor.getId()} client={client} device={sensor} onDragZoom={onDragZoom} showExpand={false}/>
        </li>
    );
  });

  if (isLoadingUser || isLoadingSensors) {
    return (
        <>
          <div className={errClassName}>{errMessage}</div>
          <div className="sensor-list">
            <ul>
              <li className="sensor-list-empty-state">
                <PulseLoader speedMultiplier={0.8} color="#629af0"/>
              </li>
            </ul>
          </div>
        </>
    );
  }

  if (!user) {
    return;
  }

  return (
      <>
        <div className="device-list">
          <ul>
            {charts.length > 0 && charts}
            {charts.length === 0 && (
                <li className="sensor-list-empty-state">No Govee pressure sensors found</li>
            )}
          </ul>
        </div>
      </>

  );
};

export default PressureSensorList;
